<template>
	<div class="kfFixed2" v-if="active_status==1 || (active_status==0&&wait_active_cnt==1) ">
		<img border="0" src="https://static.ccxia.cn/Uploads/lottery/2301/63b647a7c0b7e.png" alt="点击这里给我发消息" title="点击这里给我发消息"/>
		<p>扫码咨询客服</p>
	</div>
</template>

<script>

	import Cookies from "js-cookie";
	
	export default {
	  name: 'kfboxCompent',
	   components: {
	
	  },
	  data () {
	    return {

	    
	    }
	  },
	  props: ['active_status','wait_active_cnt'],
	  watch: {
	     active_status : function(n,o){
			this.active_status = n;
	    },
	     wait_active_cnt : function(n,o){
	     	this.wait_active_cnt = n;
	    }
	
	  },
	  methods:{

	 
	
	  },
	  created(){
	  	console.log(this.active_status)
	  	 
	  },
	  mounted(){
	
	  }
	}
</script>

<style scoped  type="text/scss" lang="scss" >
	 .kfFixed2{
    	position: fixed;
    	right: 10px;
    	bottom: 100px;
    	background: #FFFFFF;
    	border: 1px solid #000000;
    	border-radius: 10px;
    	overflow: hidden;
    	img{
    		width: 85px;
    		margin: 5px;
    	}
    	p{
    		font-size: 14px;
    		text-align: center;
    		line-height: 20px;
    		margin: 0 0 5px;
    		padding: 0;
    	}
    }

</style>


// WEBPACK FOOTER //
// src/components/kefubox.vue